import { Button, Anchor } from "@svea/design-system-components-react";
import { Stack, useLogin, useText } from "@sveabank/cc-common";
import { Link, Outlet } from "react-router";
import Header from "../components/header";
import PageContainer from "../components/page-container";
import PageFooter from "../features/page-footer";
import HeadingLayout from "./heading-layout";

const DashboardLayout = () => {
	const [t, texts] = useText();
	const { doLogout } = useLogin();

	return (
		<>
			<Header>
				<Stack gap={8} direction="row" grow={false}>
					<Anchor
						as={Link}
						to={t(texts.header.helpLink)}
						hasUnderline
						iconEnd="externalLink"
						target="_blank"
					>
						{t(texts.header.help)}
					</Anchor>
					<Button variant="plain" size="md" iconStart="logOut" onPress={() => doLogout()}>
						<span>{t(texts.header.logout)}</span>
					</Button>
				</Stack>
			</Header>

			<HeadingLayout />
			<PageContainer>
				<Outlet />
			</PageContainer>
			<PageFooter />
		</>
	);
};

export default DashboardLayout;
